export const tableItemButton = {
  ARROW: 'arrow',
  COPY: 'copy'
}
